import table from "@/domains/local-db/account/settings/adapter";
import config from "@/domains/local-db/account/settings/config";
import { CollectionsListPageParams } from "@/store/pages/CollectionsListPageStore/types";
import { NotesSearchParams } from "@/store/note";
import { NotesListPageParams } from "@/modules/filters/notes/types";

export const setNotesListPageParams = async (params: NotesSearchParams) => {
  const paramsString = JSON.stringify(params);
  return table.set(config.NOTES_LIST_PAGE_PARAMS_KEY, {
    [config.NOTES_LIST_PAGE_PARAMS_KEY]: paramsString,
  });
};

export const setCollectionsListPageParams = async (params: CollectionsListPageParams) => {
  const paramsString = JSON.stringify(params);
  return table.set(config.COLLECTIONS_LIST_PAGE_PARAMS_KEY, {
    [config.COLLECTIONS_LIST_PAGE_PARAMS_KEY]: paramsString,
  });
};

export const setCollectionsViewPageParams = async (
  collectionId: string,
  params: NotesListPageParams
) => {
  const paramsString = JSON.stringify(params);
  return table.set(config.getCollectionsViewPageParamsKey(collectionId), {
    [config.COLLECTIONS_VIEW_PAGE_PARAMS_KEY]: paramsString,
  });
};

export const removeCollectionsViewPageParams = async (collectionId: string) => {
  return table.remove(config.getCollectionsViewPageParamsKey(collectionId));
};

export const removeCollectionsListPageParams = async () => {
  return table.remove(config.COLLECTIONS_LIST_PAGE_PARAMS_KEY);
};

export const removeTemplatesListPageParams = async () => {
  return table.remove(config.TEMPLATES_LIST_PAGE_PARAMS_KEY);
};

export const removeNotesListPageParams = async () => {
  return table.remove(config.NOTES_LIST_PAGE_PARAMS_KEY);
};
